<!-- src/App.vue -->

<template>
  <main>
        <GalleryPagePart1ArtGallery v-if="user && user.id" :userId="user.id" :userSettings="userSettings" />
  </main>
</template>

<script>
  //import imageBlock from './../../components/imageBlock.vue';
  import GalleryPagePart1ArtGallery from '@/GalleryPagePart1ArtGallery.vue';
  import axios from 'axios';
  import 'animate.css';

  export default {
    name: 'GalleryPage',
    components: {
    //imageBlock,
    GalleryPagePart1ArtGallery,

    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        showB1:  false,
        showB2:  false,
        showB3:  false,
        showB4:  false,
        showB5:  false,
        isClassAdded: false,
        apiUrl: '',
        user: null,
        userSettings: null,
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      },
      addClass(event) {
      // Prevent the default navigation
      event.preventDefault();

      // Add the class to trigger the animation
      this.isClassAdded = true;

      // Wait for the animation to complete before navigating
      // Assuming the animation duration is 1 second (1000 milliseconds)
      setTimeout(() => {
        window.location.href = this.apiUrl;
      }, 1000); // Adjust the timeout duration based on your actual animation duration
    },
    fetchUserData(userId) {
      const base = process.env.NODE_ENV === 'production'
        ? ''
        : 'http://localhost:3002';

      axios.get(`${base}/api/user/${userId}`)
        .then(response => {
          this.user = response.data;
          return axios.get(`${base}/api/userSettings/${this.user.id}`);
        })
        .then(response => {
          this.userSettings = response.data;
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
          this.user = null;
        });
    },
    },
    mounted(){
      document.title = "Sinless Project Gallery";
    },
    created() {
      const userAgent = navigator.userAgent;
      if (process.env.NODE_ENV === 'production' || (/Mobi|Android/i.test(userAgent))) {
        this.apiUrl = 'https://dev.sinlessproject.com/subTitleFont';
      } else {
        this.apiUrl = 'http://localhost:8080/subTitleFont';
      }

      this.fetchUserData('lordxv');
  },
  }

</script>